import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormlyFillHeightListHostDirective } from '../formly-tabs/formly-fill-height-list-host.directive';
import { ButtonModule } from 'primeng/button';
import { ShopIntegrationCardListComponent } from '../../../shared/components/shop-integration-card-list/shop-integration-card-list.component';

@Component({
  selector: 'app-formly-product-shop-integration-link-list',
  templateUrl: './formly-product-shop-integration-link-list.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [FormlyFillHeightListHostDirective],
  imports: [CommonModule, ButtonModule, ShopIntegrationCardListComponent]
})
export class FormlyProductIntegrationLinkListComponent extends FieldType {
}
